<button mat-icon-button [disabled]="hidden" (click)="onClick($event)">
  <elm-icon *ngIf="!hidden" icon="remove-circle-1" class="elm-size-icon-s elm-color-icon-action-grey"> </elm-icon>
</button>
